"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyType = exports.HorizontalAlignDirection = exports.TextAlignDirection = void 0;
require("react");
var TextAlignDirection;
(function (TextAlignDirection) {
    TextAlignDirection["LEFT"] = "left";
    TextAlignDirection["CENTER"] = "center";
    TextAlignDirection["RIGHT"] = "right";
})(TextAlignDirection = exports.TextAlignDirection || (exports.TextAlignDirection = {}));
var HorizontalAlignDirection;
(function (HorizontalAlignDirection) {
    HorizontalAlignDirection["START"] = "flex-start";
    HorizontalAlignDirection["CENTER"] = "center";
    HorizontalAlignDirection["END"] = "flex-end";
})(HorizontalAlignDirection = exports.HorizontalAlignDirection || (exports.HorizontalAlignDirection = {}));
var CurrencyType;
(function (CurrencyType) {
    CurrencyType["USD"] = "$";
    CurrencyType["EURO"] = "\u20AC";
})(CurrencyType = exports.CurrencyType || (exports.CurrencyType = {}));
